<template lang="pug">
div
  h1.title Publicações
  listagem(@changePublicacoes="(publicacoes) => this.publicacoes = publicacoes" tipo="PUBLICACAO")
  </template>

<script>
import Listagem from '@/screens/portal/publico/components/Listagem'

export default {
  data () {
    return {
      publicacoes: [],
      isPa: process.env.ESTADO === 'pa'
    }
  },

  components: {
    Listagem
  },

  methods: {
    checkEstado (estado) {
      return process.env.ESTADO === estado
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';

.title {
  color: $color-primary;
}

.main {
  color: $font-color;
  text-align: left;
  padding: 0 10% 0 10%;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/Publicacao.vue